<template>
    <div class="bid-plan-approval-container">
        <div class="title-container">
            <span class="sub-title">{{ title }}</span>
            <i :class="contentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handleCollapse"></i>
        </div>
        <div class="content" v-if="isOpportunity&&contentVisible">
            <el-row>
                <el-col class="has-bg right-text" :span="3">招标名称</el-col>
                <el-col :span="5">{{ formData.bidName }}</el-col>
                <el-col class="has-bg right-text" :span="3">招标方式</el-col>
                <el-col :span="5">{{ formData._bidPlanType }}</el-col>
                <el-col class="has-bg right-text" :span="3">分公司</el-col>
                <el-col :span="5">{{ formData.companyName }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">经营中心</el-col>
                <el-col :span="5">{{ formData.centerName }}</el-col>
                <el-col class="has-bg right-text" :span="3">服务平台</el-col>
                <el-col :span="5">{{ formData.siteName }}</el-col>
                <el-col class="has-bg right-text" :span="3">运作省份</el-col>
                <el-col :span="5">{{ formData.operatingProvName }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">运作城市</el-col>
                <el-col :span="5">{{ formData.operatingCityName }}</el-col>
                <el-col class="has-bg right-text" :span="3">项目编码</el-col>
                <el-col :span="5">{{ formData.projectCode }}</el-col>
                <el-col class="has-bg right-text" :span="3">商机编号</el-col>
                <el-col :span="5">{{ formData.opportunityCode }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">客户名称</el-col>
                <el-col :span="5">{{ formData.customerName }}</el-col>
                <el-col class="has-bg right-text" :span="3">项目状态</el-col>
                <el-col :span="5">{{ formData._projectStatus }}</el-col>
                <el-col class="has-bg right-text" :span="3">行业类型</el-col>
                <el-col :span="5">{{ formData._industryType }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">业务大类</el-col>
                <el-col :span="5">{{ formData._bigCdBusinessType }}</el-col>
                <el-col class="has-bg right-text" :span="3">业务类型</el-col>
                <el-col :span="5">{{ formData._businessType }}</el-col>
                <el-col class="has-bg right-text" :span="3">专业公司</el-col>
                <el-col :span="5">{{ formData._professionalCompany }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">年度规模（元）</el-col>
                <el-col :span="5">{{ formData.expectedSize }}</el-col>
                <el-col class="has-bg right-text" :span="3">实际中标规模（万元）</el-col>
                <el-col :span="5">{{ formData.cdBidScale }}</el-col>
                <el-col class="has-bg right-text" :span="3">实际中标采购毛利率</el-col>
                <el-col :span="5">{{ formData.actualBidProcurementGrossMargin }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">上游合同开始时间</el-col>
                <el-col :span="5">{{ formData.upstreamContractStartTime }}</el-col>
                <el-col class="has-bg right-text" :span="3">上游合同结束时间</el-col>
                <el-col :span="5">{{ formData.upstreamContractEndTime }}</el-col>
                <el-col class="has-bg right-text" :span="3"><span v-if="pfuVisible">指定议价链接</span></el-col>
                <el-col :span="5">
                  <span 
                    v-if="pfuVisible" 
                    style="word-break: break-all; white-space: pre-line;"
                  >
                    {{ formData.priceFixUrl }}
                  </span>
                </el-col>
            </el-row>
        </div>
        <div class="content" v-if="isContract&&contentVisible">
            <el-row>
                <el-col class="has-bg right-text" :span="3">招标名称</el-col>
                <el-col :span="5">{{ formData.bidName }}</el-col>
                <el-col class="has-bg right-text" :span="3">招标方式</el-col>
                <el-col :span="5">{{ formData._bidPlanType }}</el-col>
                <el-col class="has-bg right-text" :span="3">合同号（原）</el-col>
                <el-col :span="5">{{ formData.legalContractCode }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">分公司</el-col>
                <el-col :span="5">{{ formData.companyName }}</el-col>
                <el-col class="has-bg right-text" :span="3">经营中心</el-col>
                <el-col :span="5">{{ formData.centerName }}</el-col>
                <el-col class="has-bg right-text" :span="3">服务平台</el-col>
                <el-col :span="5">{{ formData.siteName }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">运作省份</el-col>
                <el-col :span="5">{{ formData.operatingProvName }}</el-col>
                <el-col class="has-bg right-text" :span="3">运作城市</el-col>
                <el-col :span="5">{{ formData.operatingCityName }}</el-col>
                <el-col class="has-bg right-text" :span="3">客户名称</el-col>
                <el-col :span="5">{{ formData.customerName }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">业务类型</el-col>
                <el-col :span="5">{{ formData._businessType }}</el-col>
                <el-col class="has-bg right-text" :span="3">专业公司</el-col>
                <el-col :span="5">{{ formData._professionalCompany }}</el-col>
                <el-col class="has-bg right-text" :span="3">年度规模（元）</el-col>
                <el-col :span="5">{{ formData.expectedSize }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">实际中标规模（万元）</el-col>
                <el-col :span="5">{{ formData.cdBidScale }}</el-col>
                <el-col class="has-bg right-text" :span="3">实际中标采购毛利率</el-col>
                <el-col :span="5">{{ formData.actualBidProcurementGrossMargin }}</el-col>
                <el-col class="has-bg right-text" :span="3">原合同开始时间 </el-col>
                <el-col :span="5">{{ formData.upstreamContractStartTime }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">原合同结束时间</el-col>
                <el-col :span="5">{{ formData.upstreamContractEndTime }}</el-col>
                <el-col class="has-bg right-text" :span="3"><span v-if="pfuVisible">指定议价链接</span></el-col>
                <el-col :span="5">
                    <span 
                        v-if="pfuVisible" 
                        style="word-break: break-all; white-space: pre-line;"
                    >
                        {{ formData.priceFixUrl }}
                    </span>
                </el-col>
                <el-col class="has-bg right-text" :span="3"> </el-col>
                <el-col :span="5"></el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { firstDataByFdId } from '../../../api/tendering/biddingProcurementPlan.js'
import { dictWithUrl } from '@/components/lots/api'

export default {
    props: {
        auditId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            contentVisible: true,
            isContract: false,//是否是合同
            isOpportunity: false,//是否是商机
            planFdId:'',
            title: '',
            dictData: {},
            formData: {
                bidName: '-',
                bidPlanType: '-',
                _bidPlanType: '-',
                companyName: '-',
                centerName: '-',
                siteName: '-',
                operatingProvName: '-',
                operatingCityName: '-',
                projectCode: '-',
                opportunityCode: '-',
                customerName: '-',
                projectStatus: '-',
                industryType: '-',
                bigCdBusinessType: '-',
                businessType: '-',
                professionalCompany: '-',
                expectedSize: '',
                cdBidScale: '-',
                actualBidProcurementGrossMargin: '-',
                upstreamContractStartTime: '-',
                upstreamContractEndTime: '-',
                legalContractCode: '-',
                priceFixUrl: '-',
            },
            pfuVisible: false,
        }
    },
    mounted() {
        let bidRadioVal = this.$route.query.bidRadioVal
        this.planFdId = this.$route.query.processId
        this.isOpportunity = false
        this.isContract = false
        if (bidRadioVal === '3') {
            this.title = '商机信息'
            this.isOpportunity = true
        } else if (bidRadioVal === '4') {
            this.title = '合同信息'
            this.isContract = true
        }
        // else if(bidPlanType=='1'){
        //     this.title='统配线路信息'
        // }else if(bidPlanType=='2'){
        //     this.title='统配线路信息'
        // }
        this.loadDictData()
    },
    methods: {
        loadDictData() {
            // 业务大类 SRM_BUS_TYPE
            // 项目状态 SRM_CUSTOMER_PROJECT_STATUS
            // 行业类型 SYS_INDUSTRY_TYPE
            // 业务类型 BID_BUSINESS_TYPE
            // 专业公司 SYS_PROFESSIONAL_COMPANY
            // 招标方式 SU_BID_PLAN_TYPE
            dictWithUrl(
                'SRM_BUS_TYPE,SRM_CUSTOMER_PROJECT_STATUS,SYS_INDUSTRY_TYPE,BID_BUSINESS_TYPE,SYS_PROFESSIONAL_COMPANY,SU_BID_PLAN_TYPE',
            )
                .then(res => {
                    if (res && +res.code === 0) {
                        this.dictData = res.data
                        this.loadData()
                    }
                })
                .catch(err => {})
        },
        loadData() {
            if (!this.planFdId) return
            firstDataByFdId({ planFdId: this.planFdId })
                .then(res => {
                    if (res && +res.code === 0) {
                        let resData = res.data
                        if(resData){
                            resData._projectStatus = this.dictData.SRM_CUSTOMER_PROJECT_STATUS[resData.projectStatus]
                            resData._bigCdBusinessType = this.dictData.SRM_BUS_TYPE[resData.bigCdBusinessType]
                            resData._professionalCompany = this.dictData.SYS_PROFESSIONAL_COMPANY[resData.professionalCompany]
                            resData._bidPlanType = this.dictData.SU_BID_PLAN_TYPE[resData.bidPlanType]
                            resData._businessType = '';
                            resData._industryType = '';
                            if(resData.industryType){
                                let industryTypeList= resData.industryType.split(',')
                                let industryTypeNameList = [];
                                for (const item of industryTypeList) {
                                    industryTypeNameList.push(this.dictData.SYS_INDUSTRY_TYPE[item])
                                }
                                resData._industryType = industryTypeNameList.join(',')
                            }

                            if(resData.businessType){
                                let businessTypeList= resData.businessType.split(',')
                                let businessTypeNameList = [];
                                for (const item of businessTypeList) {
                                    businessTypeNameList.push(this.dictData.BID_BUSINESS_TYPE[item])
                                }
                                resData._businessType = businessTypeNameList.join(',')
                            }
                            // 40 招标方式 为 指定议价 
                            if(resData.bidPlanType === '40'){
                                this.pfuVisible = true
                            }
                        }
                                    // 业务大类 SYS_SUPPLIER_INDUSTRY
            // 项目状态 SRM_CUSTOMER_PROJECT_STATUS
            // 行业类型 SYS_INDUSTRY_TYPE
            // 业务类型 BID_BUSINESS_TYPE
            // 专业公司 SYS_PROFESSIONAL_COMPANY
                        this.setFormData(res.data)
                    }
                })
                .catch(err => {})
        },
        setFormData(data) {
            if (!data) return

            Object.assign(this.formData, data)
        },
        handleCollapse() {
            this.contentVisible = !this.contentVisible
        },
    },
    // watch: {
    //     auditId: {
    //         handler(newVal) {
    //             if (newVal) {
    //                 this.loadData()
    //             }
    //         },
    //         immediate: true
    //     }
    // }
}
</script>

<style lang="less">
.bid-plan-approval-container{
    margin-bottom: 20px;
    font-size: 14px;
    color: #000;

    .el-row {
        display: flex;
        width: 100%;
    }

    .el-col {
        float: none;
    }

    .sub-title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .title-container {
        margin-top: 15px;
        margin-bottom: 5px;

        i {
            float: right;
            padding-right: 10px;
            font-size: 24px;
            cursor: pointer;
        }
    }

    .content {
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
    }

    .has-bg {
        background: #f5f7fa;
    }

    .right-text {
        text-align: right;
    }

    .el-col {
        padding: 5px;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        min-height: 30px;
    }
}
</style>
